import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $data: InstallationCreateInput!
  ) {
    createOneInstallation(data: $data) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Instalação criada`, mutationTypes.CREATE)
)
